import React, {Component} from 'react';
import './loginform.css';
import G from './img/g.png';
import F from './img/f.png';
import {withRouter} from "react-router-dom";

import axios from 'axios';

import Modal from 'react-responsive-modal';
import ReactLoading from 'react-loading';
import cookie from 'react-cookies';
import moment from 'moment';
import 'moment/locale/zh-hk';
import 'moment/locale/en-gb';

import 'url-search-params-polyfill';
import Config from '../../config';

const now = moment();
now.locale('en-gb').utcOffset(8);

const ROOT_URL = Config.ROOT_URL;

//const ROOT_URL = "http://localhost:1337";
class LoginForm extends Component{
  state ={
    username: "",
    password: "",

    isLogin: false,
    account: {},
    error:"",
    submitBtnText:"LOGIN",
    formTitle:"Log In",
    open:false,
  }
  constructor(props) {
    super(props)
  }


  login = () =>{

    const params = new URLSearchParams();
    params.append("username", this.state.username);
    params.append("password", this.state.password);
    this.setState({
      open:true,
    });
    axios.post(`${ROOT_URL}/users/login`, params)
    .then(res => {
      const results = res.data;
      console.log(results);
      this.setState({
        open:false,
      });
      if (results.id){
        cookie.save('userId', results.id, { path: '/' });
        cookie.save('username', results.name, { path: '/' });
        window.location.href = '/dashboard';
        this.props.history.push({
          pathname: '/dashboard',
        })
      }else{
        console.log(res.data);

        this.setState({
          error: results.message,
        })
      }
    });
  }

  onLoginClick = () =>{
    if (this.state.username === "" || this.state.password === ""){
      this.setState({
        error:"Username and password cannot be empty.",
      });
      return;
    }else{
      this.login();
    }
  }
  updateUsername = (evt) =>{
    this.setState({
      username: evt.target.value
    });
  }
  updatePassword = (evt) =>{
    this.setState({
      password: evt.target.value
    });
  }

  handlePointerChange = () => {
    let loginBtn = document.querySelector('#loginBtn')
    loginBtn.style.cursor = 'pointer';
  }

  onLoginFailure = (err) =>{
    this.setState({
      error: err,
    })
  }

  componentDidMount(){

  }
  render() {
    return (
      <div className="loginform">
      <Modal open={this.state.open} center closeOnOverlayClick={false} closeOnEsc={false} onClose={()=>{this.setState({open:false})}} showCloseIcon={false}>
                <ReactLoading type="spin" color="#ad8353" />
      </Modal>
        <p className="loginformTitle">{this.state.formTitle}</p>
        <div className="error loginformRow"><p>{this.state.error}</p></div>
        <div className="loginformRow">
          <input id="username" type="text" className="loginformField" value={this.state.username} onChange={this.updateUsername} placeholder="Username"/>
        </div>
        <div className="loginformRow">
          <input id="password" type="password" className="loginformField" value={this.state.password} onChange={this.updatePassword} placeholder="Password"/>
        </div>
        <div className="loginformRow">
        <div id="loginBtn" className="loginformButton" onClick={this.onLoginClick} onMouseEnter={this.handlePointerChange}><p>{this.state.submitBtnText} <i className="fas fa-arrow-right margin-left-16"></i></p></div>
        </div>

      </div>
    );
  }
}

export default withRouter(LoginForm);
